import React, { FC, memo } from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import Button from "~/shared/ui/Fields/Button";

import s from "./NotificationRight/styles.less";

interface IProps {
  items: any;
  onClickIcon: (id) => void;
}

const Body: FC<IProps> = ({ items, onClickIcon }) => {
  const { t } = useTranslation();
  return items.map(({ id, status, label, content }) => {
    const isConfirm = status === "confirm";

    return (
      <div key={id} className={s.item}>
        <span>
          {t(`common.statuses.${status}`)}
          {isConfirm && (
            <a href={content}>
              <span> {label || "Файл готов к скачиванию"}</span>
            </a>
          )}
        </span>
        <Button
          onlyIcon
          onClick={() => onClickIcon(id)}
          customClassName={s.align_icon}
        >
          <div
            className={clsx({
              [s[status]]: true,
              [s.close]: true,
            })}
          />
        </Button>
      </div>
    );
  });
};

export default memo(Body);
